<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" :simple="true" />

    <div class="border">
      <h4>Статус: {{ item.state }}</h4>
      <h6>Абонент: {{ item.phone }}</h6>
      <h6>Чек: {{ item.number }}</h6>
      <h6>PLAN: {{ item.plan }}</h6>
      <h6>Дата: {{ item.created_at | dateTimeFormat }}</h6>

      <button
        v-if="item.state === 'reject' || item.state === 'start'"
        @click="updateItem"
        class="btn btn-danger mt-4"
      >
        Переотправить
      </button>
    </div>

    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="refresh">
        <span class="ti-save"></span>{{ "update" | setText("Обновить") }}
      </button>
    </div>

    <ul class="border">
      <li
        v-show="req.state !== 'start'"
        v-for="(req, key) in item.service_requests"
        :key="key"
      >
        <h4>{{ req.state }} - {{ req.created_at | dateTimeFormat }}</h4>
        <h5>Запрос:</h5>
        <code>
          <pre>{{ req.body }}</pre>
        </code>
        <h5>Ответ:</h5>
        <code>
          <pre>{{ req.response }}</pre>
        </code>
        <hr />
      </li>
    </ul>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "certified_checks",
    cardSetLink: "certified_checks",
    item: null,
    fields: [],
  }),

  props: ["id"],
  async created() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.item = await this.cardContent(this.cardLink, this.id);
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
